// on load we need to attach listeners and check vehicle compatibility
document.addEventListener("DOMContentLoaded", async function () {

    let section = document.querySelector('.collection');

    // functions to attach listeners
    // we need to reattach listeners after each section render
    function attachListeners() {
        // listen for filter link, render filter section
        document.querySelectorAll('.collectionFilterItemLink').forEach(element => {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                renderSection(this.href);
            });
        });

        // listen for pagination, render section
        document.querySelectorAll('.collectionPagination a')?.forEach(element => {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                renderSection(this.href);
            });
        });


        // listen for filter remove, render section
        document.querySelectorAll('.collectionFilterClear').forEach(element => {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                renderSection(this.href);
            });
        });


        // setup Dropdowns
        document.querySelectorAll(".collectionMobileTop").forEach(element => {
            element.addEventListener("click", function () {
                this.classList.toggle("active");
            });
        });

    }

    // On load, attach listeners
    attachListeners();


    /**************
     RENDER SECTION
     *************/

    // hit section rendering API to get the section
    async function renderSection(url) {
        // add section id param to the url
        let newURL = new URL(url);

        // check for section_id param and remove
        // if they refresh the page and the URL contains the section_id,
        // it will only render that section, which is not what we want
        newURL.searchParams.delete('section_id');

        // update the URL so that it keeps track of the filters
        history.replaceState(null, null, `?${newURL.searchParams.toString()}`);

        document.querySelector('.collectionLoading').classList.add('active');

        // re-add section_id param
        // newURL.searchParams.set('section_id', section.id);
        fetch(newURL)
            .then(response => response.text())
            .then(text => {
                // create temp div to parse tempHTML
                let HTML = document.createElement('div');
                HTML.innerHTML = text;

                // parse html for section
                HTML = HTML.querySelector('.collection');

                // insert sectionHTML
                if (HTML && HTML.innerHTML.trim().length) {
                    section.innerHTML = HTML.innerHTML;

                    section = document.querySelector('.collection');

                    // reattach event listeners
                    attachListeners();
                    initQuickAdd();

                    // scroll to top of section
                    section.scrollIntoView({behavior: 'smooth'});

                    document.querySelector("body").classList.remove("noScroll");

                    document.querySelector('.collectionLoading').classList.remove('active');
                }
            })
            .catch(e => {
                console.error(e);
                document.querySelector('.collectionLoading').classList.remove('active');

            });
    }
});